<template>
  <pop-up-layout
    :title="!editar ? localization.titleCrear : localization.titleEditar + ' ' + codigo"
    :description="localization.subtitle"
    :loading="loading"
    :saving="waitingForLoad"
    :aceptar="!editar ? 'Aceptar' : 'Modificar inmuebles'"
    @volver="cerrarPopup()"
    @aceptar="enviarOperacion()"
  >
    <Alerts></Alerts>
    <v-form v-model="valid" id="valid" ref="formOperaciones" autocomplete="off" >
      <v-col cols="12">
        <v-row class="pl-6" :class="editar ? 'text-xs-center justify-center' : ''">
          <v-col cols="12" md="4" v-if="!editar">
            <v-autocomplete
                  v-model="promocionSelectedId" 
                  id="promocionSelectedId"
                  :items="promociones"
                  item-text="name"
                  item-value="id"
                  :label="localization.promocion"
                />
          </v-col>
          <v-col :cols="editar ? '8' : '4'" :md="editar ? '8' : '4'"  >
            <div @click="abrirPopUpSeleccionInmueble()" >
              <v-autocomplete
                :label="localization.inmueble"
                v-model="inmuebleSelectedIds" 
                id="inmuebleSelectedIds"
                :items="inmuebles"
                :rules="[rules.required]"
                item-value="inmuebleId"
                item-text="nombreCompleto"
                :disabled="promocionSelectedId === null"
                multiple
                readonly
              />
            </div>
          </v-col>
          <v-col cols="4" md="4" v-if="!editar">
            <v-text-field
              v-model="codigoAdded" 
              id="codigoAdded"
              maxlength="7"
              :rules="[rules.obligatorio, rules.maxOperacion(this.codigoAdded.length + this.prefix.length, 7)]"
              :label="localization.codigo"
              :prefix="this.prefix"
            />
          </v-col>
          <v-col cols="6" md="6" v-if="!editar">
            <v-autocomplete
              v-model="clienteSelectedId" 
              id="clienteSelectedId"
              :rules="[rules.obligatorio]"
              :items="clientesPromo"
              item-text="nombre"
              item-value="id"
              :label="localization.cliente"
            />
          </v-col>
          <v-col cols="2" md="2" v-if="!editar">
            <v-autocomplete
              v-model="ambitoSelectedId" 
              id="ambitoSelectedId"
              :rules="[rules.obligatorio]"
              :items="ambitos"
              item-text="name"
              item-value="id"
              :label="localization.ambito"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-form>

      <custom-dialog
        v-if="abrirPopUpSeleccion === true"
        v-model="abrirPopUpSeleccion" 
        id="abrirPopUpSeleccion"
        :sinBackground="true"
      >
        <PopUpSeleccionarInmueblesRolAdmin
          @selected="reciboInmueble($event)"
          :multiple="true"
          :yaSeleccionado="inmueblesYaSeleccionados"
          :promoId="promocionSelectedId"
          :operacion="true"
        />
      </custom-dialog>
      <ConfirmDialogOperationsUsed  @add="enviarRelacionadas($event)"
      :textoTitulo="textDialog"
      @cancel="popUpInmueblesYaAsociados = false" :dialogFlag="popUpInmueblesYaAsociados" :itemAdd="inmueblesUsadosOtraOperacion"/>
  </pop-up-layout>
</template>

<script>
import { mapActions } from 'vuex'
import rulesMixin from '@/components/generic/rules.js'
import Alerts from '@/components/Alerts'
import PopUpSeleccionarInmueblesRolAdmin from '../../incidencias/PopUpSeleccionarInmueblesRolAdmin.vue'
import ConfirmDialogOperationsUsed from '../../custom/confirmDialogOperationsUsed'

export default {
  components: {
    Alerts,
    PopUpSeleccionarInmueblesRolAdmin,
    ConfirmDialogOperationsUsed
  },
  mixins: [rulesMixin],
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    editar: Boolean,

  },
  data () {
    return {
      valid: false,
      waitingForLoad: false,
      loading: false,
      clienteSelectedId: null,
      inmuebleSelectedIds: [],
      inmuebleSelectedId: null,
      inmueblesYaSeleccionados: [],
      promocionSelectedId: null,
      promocionSelected: null,
      ambitoSelectedId: null,
      abrirPopUpSeleccion: false,
      codigoAdded: '',
      prefix: '',
      inmueblesUsadosOtraOperacion: [],
      inmueblesABorrar: [],
      operacionAdd: {},
      popUpInmueblesYaAsociados: false,
      textDialog: '',
    }
  },
  async created () {
      this.loading = true
      let value = {
          promocionId: this.promocionSelectedId
        }
      await this.getClientesPromo(value)
      if(this.item != null){
      this.promocionSelectedId = this.item.promocionId
      await this.getPropertiesByIdPromotion(this.promocionSelectedId)
      this.loading = false
      }
      else{
        this.loading = false
      }
  },
  computed: {
    operacion(){
      const value = {
      code: this.codigo,
      clienteId: this.clienteSelectedId != null ? this.clienteSelectedId : null,
      inmuebleId: this.inmuebleSelectedIds,
      ambitoOperacionId: this.ambitoSelectedId != null ? this.ambitoSelectedId : null,
      }
      return value
    },
    codigo(){
      return this.prefix + this.codigoAdded
    },
    clientes(){
       if (this.$store.state.gestion.customers) {
        return this.$store.state.gestion.customers
      }
      return null
    },
    clientesPromo(){
      if(this.promocionSelected != null && this.promocionSelected.idSociedad === null && this.$store.state.gestion.customers)
      {
        return this.$store.state.gestion.customers.map( x=>{
          return {id: x.id, codigo: x.code, nombre: x.name}
        })
      }
      else if(this.$store.state.gestion.customersByPromo)
      {
        return this.$store.state.gestion.customersByPromo
      }
      else
      {
        return null
      }
    },
    inmuebles(){
      if(this.promocionSelectedId != null){
        return this.$store.state.incidencias.propertiesByStringAndPropDevId.map(x => {
          return {
            ...x,
            nombreCompleto: x.uhedit + ' - ' + x.direccion
          }
        })
      }else{
        return []
      }
    },
    promociones() {
      if (this.$store.state.gestion.promotions) {
        return this.$store.state.gestion.promotions.map(x => {
          return {
            ...x,
            nombreCompleto: x.code + ' - ' + x.name
          }
        })
      }
      return []
    },
    ambitos(){
       if (this.$store.state.gestion.ambitsOperation) {
        return this.$store.state.gestion.ambitsOperation
      }
      return null
    },
    localization () {
      return this.$t('popUpCrearOperaciones')
    },
  },
  async mounted () {
    await this.getClientes()
      await this.getPromotions()
      await this.getAmbitosOperacion()
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      getClientes: 'gestion/getClientes',
      getAmbitosOperacion: 'gestion/getAmbitosOperacion',
      getPromotions: 'gestion/getPromotions',
      getPropertiesByIdPromotion: 'incidencias/getPropertiesByIdPromotion',
      checkOperationPropertyUsed: 'gestion/checkOperationPropertyUsed',
      checkOperationsWillBeDeleted: 'gestion/checkOperationsWillBeDeleted',
      delOperationIdsArray: 'gestion/delOperationIdsArray',
      codigoUsado: 'gestion/codigoUsado',
      getClientesPromo: 'gestion/getClientesPorPromo'
    }),
    reciboInmueble(ev)
    {
      this.inmuebleSelectedIds = []
      ev.forEach(inm => this.inmuebleSelectedIds.push(inm.inmuebleId))
    },
    cerrarPopup() {
      this.$parent.hide()
      this.$parent.$parent.sheet = true
    },
    async enviarOperacion(){
      this.$refs.formOperaciones.validate()
      if (!this.valid) {
        this.addAlert({texto: 'Por favor, revise los campos marcados en rojo', color: 'error'})
      } else {
        if(!this.editar)
        {
          let codigo = {
          code: this.codigo
          }
          const repetido = await this.codigoUsado(codigo)
          if(repetido === true)
          {
            this.addAlert({texto: 'Este código ya esta asignado a una operacion activa', color: 'error'})
            return
          }

          this.inmueblesUsadosOtraOperacion = []
          let values = {inmuebleId: this.inmuebleSelectedIds}
          this.inmueblesUsadosOtraOperacion = await this.checkOperationPropertyUsed(values)
          if(this.inmueblesUsadosOtraOperacion.length != 0)
          {
            this.inmueblesUsadosOtraOperacion = this.inmueblesUsadosOtraOperacion.map(x => {
            return {
            ...x,
            nombreInmueble: this.inmuebles.find(y => y.inmuebleId === x.inmuebleId).uhedit,
              }
            })
            this.popUpInmueblesYaAsociados = true
            return
          }
        this.$emit('aceptar', this.operacion)
        this.cerrarPopup()
        }
      }
    },
    abrirPopUpSeleccionInmueble(){
      if(this.promocionSelectedId != null){
        this.inmueblesYaSeleccionados = this.inmuebleSelectedIds
        this.abrirPopUpSeleccion = true
      }
    },
    async enviarRelacionadas(seleccionadas){
      await this.delOperationIdsArray(seleccionadas)
      let idsSeleccionados = []
      seleccionadas.forEach(x=>{ idsSeleccionados.push(x.inmuebleId)})
      let inmueblesOtraOperacion = []
      this.inmueblesUsadosOtraOperacion.forEach(x=>{ inmueblesOtraOperacion.push(x.inmuebleId)})
      let excluido = inmueblesOtraOperacion.filter(o => !idsSeleccionados.includes(o))
      if(!this.editar){
        let inmueblesTotales = this.inmuebleSelectedIds
        let aEnviar = inmueblesTotales.filter(o => !excluido.includes(o))
        this.operacionAdd = {
          code: this.codigo,
          clienteId: this.clienteSelectedId != null ? this.clienteSelectedId : null,
          inmuebleId: aEnviar,
          ambitoOperacionId: this.ambitoSelectedId != null ? this.ambitoSelectedId : null,
        }
        this.$emit('aceptar', this.operacionAdd)
        this.cerrarPopup()
      }
    }
  },
  watch: {
    async promocionSelectedId (newVal, oldVal) {
      await this.getClientes()
      let value = {
          promocionId: this.promocionSelectedId
        }
        await this.getClientesPromo(value)
      if(oldVal === null)
      {
        this.promocionSelected = this.promociones.find(x => x.id === this.promocionSelectedId)
        this.prefix = this.promocionSelected.code + '/'
        return
      }
      this.promocionSelected = this.promociones.find(x => x.id === this.promocionSelectedId)
      this.prefix = this.promocionSelected.code + '/'
      await this.getPropertiesByIdPromotion(this.promocionSelectedId)
      if(newVal != oldVal){
        this.inmuebleSelectedIds = []

      }
    },
  }
}
</script>

<style scoped>
  .info-tooltip {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.54);
    font-weight: bold;
    margin-bottom: 0px;
  }
</style>
